import React, { useEffect, useState } from 'react';
import { api } from '../api';
import { useLocale } from '../i18n/LocaleContext';

export default function AccountSecurityPanel() {
  const { t, dateLocale } = useLocale();
  const [emailStatus, setEmailStatus] = useState(null);
  const [termsStatus, setTermsStatus] = useState(null);
  const [privacyStatus, setPrivacyStatus] = useState(null);
  const [requests, setRequests] = useState(null);
  const [message, setMessage] = useState('');

  const load = () => {
    api.emailVerificationStatus().then(setEmailStatus).catch(() => setEmailStatus({ verified: false }));
    api.termsStatus().then(setTermsStatus).catch(() => setTermsStatus({ accepted: false }));
    api.privacyPolicyStatus().then(setPrivacyStatus).catch(() => setPrivacyStatus({ accepted: false }));
    api.dataRightsRequests().then(result => setRequests(result.requests)).catch(() => setRequests([]));
  };

  useEffect(() => { load(); }, []);

  const requestRight = async (type) => {
    setMessage('');
    try {
      const result = await api.requestDataRight(type);
      setMessage(result.existing ? t('account.requestExisting') : t('account.requestSubmitted'));
      load();
    } catch (err) {
      setMessage(err.response?.data?.error || t('account.requestFailed'));
    }
  };

  return <>
    <div className="account-section">
      <div className="section-heading">{t('account.security')}</div>
      <div className="account-card">
        <div className="account-security-list">
          <div className="account-security-row">
            <span className="account-security-label">{t('account.email')}</span>
            <span className={`account-status-pill ${emailStatus?.verified ? 'ok' : 'pending'}`}>
              {emailStatus?.verified ? `${t('account.verified')}${emailStatus.verifiedAt ? ` · ${new Date(emailStatus.verifiedAt).toLocaleDateString(dateLocale)}` : ''}` : t('account.notVerified')}
            </span>
          </div>
          <div className="account-security-row">
            <span className="account-security-label">{t('account.terms')}</span>
            <span className={`account-status-pill ${termsStatus?.accepted ? 'ok' : 'pending'}`}>
              {termsStatus?.accepted ? t('account.acceptedVersion', { version: termsStatus.current?.version || '' }) : t('account.actionRequired')}
            </span>
          </div>
          <div className="account-security-row">
            <span className="account-security-label">{t('account.privacy')}</span>
            <span className={`account-status-pill ${privacyStatus?.accepted ? 'ok' : 'pending'}`}>
              {privacyStatus?.accepted ? t('account.acceptedVersion', { version: privacyStatus.current?.version || '' }) : t('account.actionRequired')}
            </span>
          </div>
        </div>
        {!emailStatus?.verified && <button type="button" className="btn account-security-action" onClick={() => api.requestEmailVerification().then(() => setMessage(t('account.verificationSent'))).catch(err => setMessage(err.response?.data?.error || t('account.requestFailed')))}>{t('account.sendVerification')}</button>}
      </div>
    </div>

    <div className="account-section">
      <div className="section-heading">{t('account.yourData')}</div>
      <div className="account-card">
        <p style={{ color: 'var(--text-secondary)', fontSize: '13px', marginBottom: '1rem' }}>{t('account.dataDescription')}</p>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <button type="button" className="btn" onClick={() => requestRight('export')}>{t('account.requestExport')}</button>
          <button type="button" className="btn account-danger-btn" onClick={() => requestRight('deletion')}>{t('account.requestDeletion')}</button>
        </div>
        {message && <div style={{ color: 'var(--text-secondary)', fontSize: '12.5px', marginTop: '0.75rem' }}>{message}</div>}
        {requests?.length > 0 && (
          <div className="account-timeline-card" style={{ marginTop: '1rem' }}>
            <div className="activity-list">
              {requests.map(item => (
                <div className="activity-item" key={item.id}>
                  <span className="activity-time">{item.type}</span>
                  <span className="activity-message">{item.status} — {new Date(item.createdAt).toLocaleDateString(dateLocale)}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  </>;
}
